export function postalCode($el) {
  if (!$el.val()) {
    return true;
  }
  const pattern = /^\d{2}-?\d{3}$/;
  return pattern.test($el.val());
}
Foundation.Abide.defaults.validators["postalCode"] = postalCode;
